import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// add authorization header with jwt token if available
		const jwt = localStorage.getItem('jwt');
		const currentLanguageCode = localStorage.getItem('lang');
		if (jwt) {
			request = request.clone({
				setHeaders: {
					'Authorization': `Bearer ${jwt}`,
					'X-localization': currentLanguageCode ? currentLanguageCode : 'en'
				}
			});
		}

		return next.handle(request);
	}
}
